import { Box, Skeleton, Divider } from "@mui/material";

const BrandPropertiesSkeleton = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 1,
        p: 3,
      }}
    >
      {/* Header */}
      <Skeleton width={320} height={28} />
      <Box sx={{ mt: 1, display: "flex", gap: 2 }}>
        <Skeleton width={160} height={20} />
        <Skeleton width={120} height={20} />
        <Skeleton width={140} height={20} />
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Form fields */}
      {[1, 2, 3, 4].map((_, index) => (
        <Box key={index} sx={{ mb: 3 }}>
          {/* Label */}
          <Skeleton width={180} height={18} />
          {/* Input */}
          <Skeleton
            variant="rectangular"
            height={44}
            sx={{ mt: 1, borderRadius: 0.5 }}
          />
          {/* Helper text */}
          <Skeleton width={100} height={16} sx={{ mt: 0.5 }} />
        </Box>
      ))}

      <Divider sx={{ my: 3 }} />

      {/* Footer buttons */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Skeleton variant="rectangular" width={160} height={36} />
        <Skeleton variant="rectangular" width={80} height={36} />
      </Box>
    </Box>
  );
};

export default BrandPropertiesSkeleton;
